import React from "react";
import { Routes, Route } from "react-router-dom";
import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";
import ConnectedAdherentsDock from "../components/ConnectedAdherentsDock";
import Profile from "./Profile";
import AdherentsList from "./AdherentsList";
import Referentiels from "./Referentiels";
import EventsAdherent from "./EventsAdherent";
import EventsManagement from "./EventsManagement";
import FormTemplatesList from "./FormTemplatesList";
import EngagementsList from "./EngagementsList";
import HistoriqueAdherent from "./HistoriqueAdherent";
import FamilyRequestsAdmin from "./FamilyRequestsAdmin";
import AuditLogs from "./AuditLogs";
import Actualites from "./Actualites";

export default function Dashboard() {
  return (
    <div className="app-shell">
      <TopBar />
      <div className="app-body">
        <Sidebar />
        <div className="app-main">
          <Routes>
            <Route index element={<Actualites />} />
            <Route path="profile" element={<Profile />} />
            <Route path="actualites" element={<Actualites />} />
            <Route path="adherents" element={<AdherentsList />} />
            <Route path="referentiels" element={<Referentiels />} />
            <Route path="events" element={<EventsManagement />} />
            <Route path="events-client" element={<EventsAdherent />} />
            <Route path="registrations" element={<EventsManagement />} />
            <Route path="form-templates" element={<FormTemplatesList />} />
            <Route path="engagements" element={<EngagementsList />} />
            <Route path="family-requests" element={<FamilyRequestsAdmin />} />
            <Route path="audit-logs" element={<AuditLogs />} />
            <Route path="historique" element={<HistoriqueAdherent />} />
          </Routes>
        </div>
        <ConnectedAdherentsDock />
      </div>
    </div>
  );
}
